<template>
  <tr>
    <td class="align-middle">{{ user.first_name }}</td>
    <td class="align-middle">{{ user.last_name }}</td>
    <td class="align-middle">{{ user.email }}</td>
    <td class="align-middle">{{ roles }}</td>
    <td class="align-middle text-right">
      <div v-if="!confirmation">
        <inertia-link
          class="btn btn-primary mr-2"
          :href="route('organisation.user.edit', [organisationId, user.id])"
          >Edit</inertia-link
        >
        <button @click="confirmation = true" class="btn btn-danger">
          Delete
        </button>
      </div>
      <div v-else class="align-middle">
        Are you sure?
        <button @click="confirmation = false" class="btn btn-secondary ml-2">
          No
        </button>
        <button @click="destroy" class="btn btn-danger ml-1">Yes</button>
      </div>
      <!-- <inertia-link
        class="text-danger"
        :href="route('organisation.user.destroy', [organisationId, user.id])"
      >Delete</inertia-link>-->
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    organisationId: String,
    user: Object,
  },

  data() {
    return {
      confirmation: false,
    };
  },

  computed: {
    roles() {
      const flattened = this.user.roles.flatMap((r) => r.label);
      if (flattened.length === 0) {
        return 'No Roles Set';
      }
      return flattened.join(', ');
    },
  },

  methods: {
    destroy() {

      this.$inertia.form().delete(this.route('organisation.user.destroy', [this.organisationId, this.user.id]), {
        preserveScroll: true,
        onSuccess: () => {
          this.$emit('userDeleted', this.user.id);
        },
      });
    },
  },
};
</script>
